export default {
  getStatusesItinerary(state) {
    return state.status_itinerary;
  },
  getQuoteStatuses(state) {
    return state.quoteStatuses;
  },
};
